import { useTranslation } from 'react-i18next'

export function AssetProvenanceNotice({ payload }: { payload: unknown }) {
  const { t } = useTranslation()
  let value: unknown = payload
  if (typeof value === 'string') {
    try { value = JSON.parse(value) } catch { return null }
  }
  if (!value || typeof value !== 'object') return null
  const provenance = (value as { provenance?: { kind?: string; reasons?: unknown } }).provenance
  if (!provenance || !['degraded', 'placeholder'].includes(provenance.kind ?? '')) return null
  const reasons = Array.isArray(provenance.reasons) ? provenance.reasons.filter((reason): reason is string => typeof reason === 'string') : []
  return <aside role="status" className="space-y-2 rounded-md border p-3 text-sm">
    <p className="font-semibold">{t(reasons.includes('degraded_clip_unavailable') ? 'mediaProvenance.storyboard' : 'mediaProvenance.title')}</p>
    <ul className="list-disc space-y-1 pl-5">{[...new Set(reasons)].map((reason) => {
      const [code, ...detail] = reason.split(':')
      return <li key={reason}>{t(`mediaProvenance.reasons.${code}`, { defaultValue: t('mediaProvenance.other', { reason }) })}{detail.length ? ` (${detail.join(':')})` : ''}</li>
    })}</ul>
  </aside>
}
